export class IotizeProfileModel {
  public data: any;

  constructor(data: any) {
    this.data = data;
  }

  public toJson(): any {
    return this.data;
  }

  public description(): string {
    return this.data.$.GUI_Description;
  }

  public name(): string {
    return this.data.$.Name;
  }

  public id(): string {
    return this.data.$.Id;
  }
}
